module.exports = __webpack_public_path__ + "img/arrow_right.428cd5ce.png";